var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudioad({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "AudioAd",
    transform: "translate(-535 -344)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_8216",
    "data-name": "Rectangle 8216",
    transform: "translate(535 344)",
    fill: "#e8eaed",
    stroke: "#dee1e5",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    rx: 23.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 46,
    height: 46,
    rx: 23,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "speaker-filled-audio-tool_1_",
    "data-name": "speaker-filled-audio-tool (1)",
    transform: "translate(549 349.48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30480",
    "data-name": "Path 30480",
    d: "M10.65,24.655a.967.967,0,0,1-1.584.744L3.781,21.02H.967A.966.966,0,0,1,0,20.054V16.2a.967.967,0,0,1,.967-.967H3.782l5.285-4.379a.967.967,0,0,1,1.584.744V24.655Zm3.715-1.511-.07,0a.966.966,0,0,1-.683-.283l-.129-.13a.966.966,0,0,1-.093-1.259,5.621,5.621,0,0,0-.149-6.888.966.966,0,0,1,.067-1.293l.129-.129a.946.946,0,0,1,.732-.282.968.968,0,0,1,.7.353,7.742,7.742,0,0,1,.2,9.522A.967.967,0,0,1,14.365,23.145Zm4,2.987a.968.968,0,0,1-.7.342h-.04a.966.966,0,0,1-.684-.283l-.127-.127a.967.967,0,0,1-.056-1.306,10.3,10.3,0,0,0-.171-13.46.967.967,0,0,1,.039-1.323l.127-.127a.941.941,0,0,1,.713-.284.967.967,0,0,1,.695.324,12.412,12.412,0,0,1,.2,16.243Z",
    fill: "#1b1c1d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioad);
export default __webpack_public_path__ + "static/media/audioad.8755de455b4712e8dc7dbda0d2716449.svg";
export { ForwardRef as ReactComponent };